import { render, staticRenderFns } from "./Athleten.vue?vue&type=template&id=091569c0&"
import script from "./Athleten.vue?vue&type=script&lang=js&"
export * from "./Athleten.vue?vue&type=script&lang=js&"
import style0 from "./Athleten.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports